interface PageHeaderProps {
    title: string
}

export function PageHeader({title}: PageHeaderProps) {
    return <div className="px-10 py-2 bg-primary text-primary-content flex justify-center">
        <h1 className="text-2xl font-normal">{title}</h1>
    </div>
}